<template>
    <el-dialog
        class="edit"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Edit Company"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form ref="editForm" :rules="rules" :model="editForm" @keydown.enter.native.prevent>
                <el-col :span="24">
                    <el-form-item label="Company Name" size="small" prop="name">
                        <el-input
                            clearable
                            size="small"
                            v-model="editForm.name"
                            placeholder="Firstname"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Type" size="small" prop="type">
                        <el-radio-group v-model="editForm.type">
                            <el-radio label="Enterprise">Enterprise</el-radio>
                            <el-radio label="Personal">Personal</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Country" size="small" prop="country">
                        <el-select
                            v-model="editForm.country"
                            size="mini"
                            placeholder="Please select"
                            filterable
                            clearable
                        >
                            <el-option
                                v-for="item in countryList"
                                :key="item.id"
                                :label="item.name_en"
                                :value="item.name_en"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item
                        label="State/Province"
                        size="small"
                        prop="state"
                    >
                        <el-input
                            clearable
                            size="small"
                            v-model="editForm.state"
                            placeholder="State/Province"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="City" size="small" prop="city">
                        <el-input
                            clearable
                            size="small"
                            v-model="editForm.city"
                            placeholder="City"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item
                        label="Street Address"
                        size="small"
                        prop="Street"
                    >
                        <el-input
                            clearable
                            size="small"
                            v-model="editForm.address"
                            placeholder="Street"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Rank" size="small" prop="rank">
                        <el-select
                            v-model="editForm.rank"
                            size="mini"
                            placeholder="Please select"
                            filterable
                            clearable
                        >
                            <el-option
                                v-for="item in rankList"
                                :key="item.value"
                                :label="item.rank_name"
                                :value="item.rank"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item
                        label="Business Code"
                        size="small"
                        prop="business_code"
                    >
                        <el-select
                            v-model="editForm.business_code"
                            size="mini"
                            placeholder="Please select"
                            filterable
                            clearable
                        >
                            <el-option
                                v-for="item in businessCodeList"
                                :key="item.value"
                                :label="item.code + ' (' + item.business + ')'"
                                :value="item.code"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Status" size="small" prop="status" v-if="status!=='0'">
                        <el-radio-group v-model="editForm.status">
                            <el-radio :label="2" v-if="['1','3','4'].includes(status)">Actived</el-radio>
                            <el-radio :label="3" v-if="['1'].includes(status)">Rejected</el-radio>
                            <el-radio :label="4" v-if="['2'].includes(status)">Closed</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Save</el-button
            >
            <el-button size="small" @click="editVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapActions } from "vuex";
export default {
    data() {
        return {
            editForm: {
                name: "",
                type: "",
                country: "",
                state: "",
                business_code: {
                    code: "",
                },
                city: "",
                address: "",
                rank: "",
                status: "",
            },
            rules: {
                name: [
                    {
                        required: true,
                        trigger: "blur",
                    },
                ],
                address: [
                    {
                        required: true,
                        trigger: "blur",
                    },
                ],
                country: [
                    {
                        required: false,
                        trigger: "change",
                    },
                ],
                city: [
                    {
                        required: false,
                        trigger: "blur",
                    },
                ],
                rank: [
                    {
                        required: true,
                        trigger: "blur",
                    },
                ],
                status: [
                    {
                        required: true,
                        trigger: "blur",
                    },
                ],
            },
            loading: false,
            countryList: [],
            rankList: [],
            businessCodeList: [],
        };
    },
    methods: {
        ...mapActions([
            "getCountrySelect",
            "getRntityRankSelect",
            "getBusinessCodeSelect",
        ]),
        saleEntityList(page) {
            cmofferApi
                .saleEntityList({}, "get", this.tableItem.id)
                .then((res) => {
                    if (res) {
                        this.editForm = {
                            ...res.data,
                            business_code: res.data.business_code && res.data.business_code.code,
                        };
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        save() {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    cmofferApi
                        .saleEntityList(
                            {
                                ...this.editForm,
                            },
                            "post",
                            this.tableItem.id
                        )
                        .then((res) => {
                            if (res) {
                                this.loading = false;
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "编辑成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        closeDialog() {
            this.editForm = {};
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            this.$emit("update:editVisible", false);
        },
        async initialize() {
            this.saleEntityList();
            this.getCountrySelect().then((res) => {
                this.countryList = res.data;
            });
            this.getRntityRankSelect().then((res) => {
                this.rankList = res.data;
            });
            this.getBusinessCodeSelect().then((res) => {
                this.businessCodeList = res.data;
            });
        },
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
        funcName: String,
        status: Number
    },
    watch: {
        editVisible() {
            console.log("status", this.status);
            if (this.editVisible) {
                this.initialize();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.edit {
    ::v-deep .container {
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }

        .el-select {
            width: 100%;
        }

        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
        .el-radio-group {
            width: 100%;
        }
    }
    /* ::v-deep .el-dialog__footer {
        text-align: center !important;
    } */
}
</style>
